import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Image from "../../lib/Image";
import Dialog from "../../lib/Dialog";
import general from "../../general";
import { useScroll } from "ahooks";
import $ from "jquery";
import KeepScroll from "../../lib/KeepScroll";
import HeadNew from "./HeadNew";
import { splitStr } from "../../utils/commonFunc";
import { getKidCallback, userClickReport } from "../../utils/kidCallback";
import dayjs from "dayjs";

const tops = [
  {
    id: "hot",
    name: "热玩榜",
  },
  {
    id: "new",
    name: "新游榜",
  },
  {
    id: "dl",
    name: "下载榜",
  },
];

const Top = ({ active, id }) => {
  const [init, setInit] = useState();
  const [loading, setLoading] = useState();
  const [page, setPage] = useState(1);
  const [games, setGames] = useState([]);
  const [more, setMore] = useState(true);
  const load = (parms = {}) => {
    if (loading) {
      return;
    }
    setLoading(true);
    Dialog.loading();
    let tmp = {
      type: { hot: 2, new: 3, dl: 4 }[id],
      pagination: { page: page },
    };
    if (parms.page) {
      tmp.pagination = { page: parms.page };
    }
    general.axios
      .post("/v3/base/game/getGameList", tmp)
      .finally(() => {
        setLoading(false);
        Dialog.close();
      })
      .then((res) => {
        setInit(true);
        let result = res.data.data;
        if (parms.page) {
          setPage(parms.page);
        }
        setGames((games) =>
          parms.page === 1 || !parms.page
            ? result.game_list
            : [...games, ...result.game_list]
        );
        setMore(result.paginated.more);
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };
  useEffect(() => {
    if (active && !init) {
      load();
    }
  }, [active]);

  const scroll = useScroll();
  useEffect(() => {
    if (active && init) {
      if (scroll?.top < -80) {
        load({ page: 1 });
      }
      if (
        scroll?.top + window.innerHeight + 20 > $(document).height() &&
        more
      ) {
        load({ page: page + 1 });
      }
    }
  }, [active, scroll]);

  return (
    <>
      <div className="top-items">
        {games.map((game, index) => (
          <Link
            key={game.game_id}
            to={"/game?id=" + game.game_id}
            className="game-list-global-type"
            style={{
              padding: "10px 0 10px 10px",
              position: "relative",
              marginBottom: "8px",
              boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.08)",
            }}
          >
            {index < 3 ? (
              <img
                style={{
                  position: "absolute",
                  top: 0,
                  left: "5px",
                  width: "31px",
                  zIndex: 9,
                }}
                src={`/resources/common/${index + 1}.png`}
              />
            ) : (
              <div
                className="sort-content"
                style={{
                  backgroundImage: `url('/resources/common/sort-back.png')`,
                }}
              >
                {index + 1}
              </div>
            )}

            <div className="game-list-global-type-left">
              <div className="icon">
                <Image src={game?.game_image?.thumb} />
              </div>

              <div className="data">
                <div className="name">
                  <div className="name-main">
                    {game.game_name_main || game.game_name}
                  </div>

                  {game?.game_tags?.is_special_server_game == 2 && (
                    <div className="dedicated-server">专服</div>
                  )}
                </div>

                <div className="desc">
                  {splitStr(game.game_classify_type)}
                  {game.game_name_branch && (
                    <>
                      <div className="circle"></div>
                      {game.game_name_branch}
                    </>
                  )}
                </div>

                <div className="info">
                  {game.game_desc && (
                    <>
                      {game?.is_trial_game == 2 ? (
                        <>
                          <div className="play-tag">有奖试玩</div>
                          {game.game_desc
                            ?.split("+")
                            .slice(0, 1)
                            .map((item, index) => (
                              <div key={index} className="tag">
                                {item}
                              </div>
                            ))}
                        </>
                      ) : (
                        game.game_desc
                          ?.split("+")
                          .slice(0, 2)
                          .map((item, index) => (
                            <div key={index} className="tag">
                              {item}
                            </div>
                          ))
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>

            {game?.game_tags?.is_premium_game == 2 ? (
              <div
                className="is-premium"
                style={{
                  backgroundImage: "url('/resources/common/boutique.png')",
                }}
              >
                {game.discount < 1 ? (
                  <p className="is-premium-discount">
                    {parseFloat((game.discount * 10).toFixed(2))}折
                  </p>
                ) : null}
                <p className="boutique">精品游戏</p>
              </div>
            ) : game?.game_tags?.is_free_version == 2 ? (
              <div className="is-free-version">
                <span>免费版</span>
              </div>
            ) : (
              <>
                {game.discount < 1 ? (
                  <div className="discount">
                    {parseFloat((game.discount * 10).toFixed(2))}折
                  </div>
                ) : null}
              </>
            )}
          </Link>
        ))}

        {games.length > 0 && !more ? (
          <div className="view-end">别撩啦！已经到底啦~</div>
        ) : null}
      </div>
    </>
  );
};

export default (props) => {
  const [current, setCurrent] = useState("hot");

  const scroll = useScroll();
  const [searchIconShow, setSearchIconShow] = useState(false);
  useEffect(() => {
    if (scroll && scroll.top) {
      setSearchIconShow(true);
    } else {
      setSearchIconShow(false);
    }
  }, [scroll, props.active]);

  const searchStartClick = async () => {
    console.log("排行榜搜索开始点击");

    // 同步生成二级kid
    let kid = await getKidCallback();
    // 存储二级kid
    sessionStorage.setItem("boxSecondKid", kid);

    // 行为上报
    // 一级kid、二级kid都进行传递
    let reamrk = {
      search_click_time: dayjs().unix(),
      search_click_position: "排行榜",
    };
    userClickReport({
      target_action_type: "search",
      parent_id: "",
      kid,
      level: 2,
      action_code: "search_click",
      remark: JSON.stringify(reamrk),
    });
  };

  return (
    <>
      <Link
        to="/search"
        className={
          searchIconShow ? "show index-search-icon" : "index-search-icon"
        }
        onClick={searchStartClick}
      >
        <img src="/resources/common/search.png" alt="" />
      </Link>

      <div className="top-index">
        <div className="top-head width">
          {!searchIconShow && (
            <div onClick={searchStartClick}>
              <HeadNew active={props.active} />
            </div>
          )}

          <div className="width">
            {tops.map((item) => (
              <div
                key={item.id}
                className={`item ${item.id === current ? "active" : ""}`}
                onClick={() => setCurrent(item.id)}
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>
        <div className="top-body">
          {tops.map((item) => (
            <KeepScroll
              key={item.id}
              active={props.active && item.id == current}
              lazy
            >
              <div
                className={`top-group ${item.id === current ? "active" : ""}`}
              >
                <Top
                  {...{
                    ...item,
                    active: props.active && item.id === current,
                  }}
                />
              </div>
            </KeepScroll>
          ))}
        </div>
      </div>
    </>
  );
};
